"use client";

import {
  Select,
  SelectValue,
  SelectItem,
  SelectContent,
  SelectTrigger,
  type MapProjection,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { useMap } from "maplibre-react-components";
import React, { type ReactElement, useEffect } from "react";
import { mapProjectionAtom } from "@/store/sites";
import { mapProjections } from "@/utils";

function SitesMapSwitchProjection(): ReactElement {
  const map = useMap("map");
  const [mapProjection, setMapProjection] = useAtom(mapProjectionAtom);

  useEffect(() => {
    if (map) {
      map.on("style.load", () => {
        map.setProjection({
          type: mapProjection.id,
        });
      });
    }
  }, [map, mapProjection]);

  const handleChange = (value: string): void => {
    setMapProjection(mapProjections.get(value) as MapProjection);
    if (map) map.setProjection({ type: value });
  };

  return (
    <Select defaultValue={mapProjection.id} onValueChange={handleChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={mapProjection.title} />
      </SelectTrigger>
      <SelectContent>
        {Array.from(mapProjections).map(([key, projection]): ReactElement => {
          return (
            <SelectItem key={key} value={projection.id}>
              {projection.title}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}

export { SitesMapSwitchProjection };
